import Evaluation from '@/models/Evaluation';

const GET_EVALUATION = 'get_evaluation';
const GET_EVALUATION_REQUEST = 'get_evaluation_request';
const GET_EVALUATION_SUCCESS = 'get_evaluation_success';
const GET_EVALUATION_ERROR = 'get_evaluation_error';

export { GET_EVALUATION };

export default {
    state: {
        evaluation: [],
        loading: false,
        evaluationErrors: [],
        evaluationMeta: {},
    },
    mutations: {
        [GET_EVALUATION_REQUEST]: (state) => {
            state.evaluation = [];
            state.loading = true;
            state.evaluationErrors = [];
        },
        [GET_EVALUATION_SUCCESS]: (state, { evaluation, meta }) => {
            state.evaluation = evaluation;
            state.loading = false;
            state.evaluationErrors = [];
            state.evaluationMeta = meta;
        },
        [GET_EVALUATION_ERROR]: (state, { errors }) => {
            state.evaluation = [];
            state.loading = false;
            state.evaluationErrors = errors;
            state.evaluationMeta = {};
        },
    },
    actions: {
        [GET_EVALUATION]: ({ commit, state }, { params = {} }) => {
            commit(GET_EVALUATION_REQUEST);
            return new Promise((resolve, reject) => {
                // If no page specified at dispatch
                if (!params.page) {
                    // Use the current one if present, the first one othewise
                    if (state.evaluationMeta.current_page) {
                        params.page = state.evaluationMeta.current_page;
                    } else {
                        params.page = 1;
                    }
                }

                Evaluation.collection(params)
                    .then(({items, meta}) => {
                        const evaluation = items;
                        commit(GET_EVALUATION_SUCCESS, { evaluation, meta });
                        resolve(items);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_EVALUATION_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/evaluation.js